// extracted by mini-css-extract-plugin
module.exports = {"select":"ContentType_select__aNHl2"};